module.exports = __webpack_public_path__ + "71da9154b2d01d841abca01f3303b15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apdm-700.png
// module id = 168
// module chunks = 1